export default __webpack_public_path__ + "static/media/9.13cf6826.jpg";